
import type { IAPICompany } from '@hokify/common';
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { findLongestWord, shortenString } from '../helpers/stringhelper';
import { piniaAvailable } from '../helpers/piniaStoreAvailable';

export default defineComponent({
	name: 'JobListCompanySlot',
	data() {
		return {
			shortenString
		};
	},
	computed: {
		topLevelDomain(): string | undefined {
			return piniaAvailable(this.$nuxt, '$userRootStore')
				? this.$nuxt.context.$userRootStore?.topLevelDomain
				: this.$store?.state?.topLevelDomain;
		},
		host(): string | undefined {
			return piniaAvailable(this.$nuxt, '$userRootStore')
				? this.$nuxt.context.$userRootStore?.host
				: this.$store?.state?.host;
		},
		companyLink() {
			if (
				!this.company.bestAvailableRegion ||
				this.company.bestAvailableRegion === this.topLevelDomain
			) {
				return `/c/${this.company.alias}`;
			}

			const splitHost = this.host?.split('.');
			// if it fails or we are on localhost
			if (!splitHost?.length || splitHost.length === 1) {
				return `/c/${this.company.alias}`;
			}

			splitHost[splitHost.length - 1] = this.company.bestAvailableRegion;
			const url = new URL(`/c/${this.company.alias}`, splitHost.join('.'));
			return url.toString();
		}
	},
	methods: {
		nameContainsLongWord(name: string, limit = 35): boolean {
			const longestWord = findLongestWord(name);
			return longestWord.length > limit;
		}
	},
	props: {
		company: {
			type: Object as PropType<IAPICompany & { bestAvailableRegion?: string }>,
			required: true
		}
	}
});
